module.exports = __webpack_public_path__ + "static/media/86.2e496927.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/res/thumbnails/86.jpg
// module id = 1019
// module chunks = 0